export const version = "properties/5.6.0";
//# sourceMappingURL=_version.js.map